import { Routes } from '@angular/router';
import { ConnectComponent } from './core/components/connect/connect.component';
import { AutoLoginComponent } from './core/components/login/autologin.component';
import { LoginComponent } from './core/components/login/login.component';
import { UnauthorizedAccountComponent } from './core/components/unauthorized/unauthorizedAccount.component';
import { UnauthorizedContactComponent } from './core/components/unauthorized/unauthorizedContact.component';
import { AuthGuard } from './core/guards/auth.guard';
import { HomeComponent } from './home/home.component';

export const routes: Routes = [
  {
    path: '',
    component: ConnectComponent,
    children: [
      {
        path: 'accueil',
        component: HomeComponent,
        canActivate: [AuthGuard],
        data: { expectedRole: ['administrateur', 'utilisateur', 'contributeur'] }
      },
      {
        path: 'tableau-de-bord',
        loadComponent: () => import('./dashboard/dashboard.component').then((m) => m.DashboardComponent),
        canActivate: [AuthGuard],
        data: { expectedRole: ['administrateur', 'utilisateur', 'contributeur'] }
      },
      {
        path: 'profil',
        loadComponent: () => import('./administration/administration-profile/administration-profile.component').then((m) => m.AdministrationProfileComponent),
        canActivate: [AuthGuard],
        data: { expectedRole: ['administrateur', 'utilisateur', 'contributeur'] }
      },
      {
        path: 'entreprise',
        loadComponent: () => import('./administration/administration-company/administration-company.component').then((m) => m.AdministrationCompanyComponent),
        canActivate: [AuthGuard],
        data: { expectedRole: ['administrateur', 'utilisateur', 'contributeur'] }
      },
      {
        path: 'factures',
        loadComponent: () => import('./administration/administration-invoices/administration-invoices.component').then((m) => m.AdministrationInvoicesComponent),
        canActivate: [AuthGuard],
        data: { expectedRole: ['administrateur', 'utilisateur', 'contributeur'] }
      },
      {
        path: 'factures/:status',
        loadComponent: () => import('./administration/administration-invoices/administration-invoices.component').then((m) => m.AdministrationInvoicesComponent),
        canActivate: [AuthGuard],
        data: { expectedRole: ['administrateur', 'utilisateur', 'contributeur'] }
      },
      {
        path: 'documents',
        loadComponent: () => import('./administration/administration-documents/administration-documents.component').then((m) => m.AdministrationDocumentsComponent),
        canActivate: [AuthGuard],
        data: { expectedRole: ['administrateur', 'utilisateur', 'contributeur'] }
      },

      {
        path: 'utilisateurs',
        loadComponent: () => import('./administration/administration-users/administration-users.component').then((m) => m.AdministrationUsersComponent),
        canActivate: [AuthGuard],
        data: { expectedRole: ['administrateur', 'utilisateur', 'contributeur'] }
      },
      {
        path: 'collaboration',
        loadComponent: () => import('./collaboration/components/collaboration-dashboard/collaboration-dashboard.component').then((m) => m.CollaborationDashboardComponent),
        canActivate: [AuthGuard],
        data: { expectedRole: ['administrateur', 'utilisateur', 'contributeur'] }
      },
      {
        path: 'groupes-de-travail',
        loadComponent: () => import('./collaboration/components/collaboration-workgroups/collaboration-workgroups.component').then((m) => m.CollaborationWorkgroupsComponent),
        canActivate: [AuthGuard],
        data: { expectedRole: ['administrateur', 'utilisateur', 'contributeur'] }
      },
      {
        path: 'standard',
        loadComponent: () => import('./collaboration/components/collaboration-evolutions/collaboration-evolutions.component').then((m) => m.CollaborationEvolutionsComponent),
        canActivate: [AuthGuard],
        data: { expectedRole: ['administrateur', 'utilisateur', 'contributeur', 'Fédération'] }
      },
      {
        path: 'standard/create',
        loadComponent: () =>
          import('./collaboration/components/collaboration-evolutions/components/collaboration-evolutions-create/collaboration-evolutions-create.component').then(
            (m) => m.CollaborationEvolutionsCreateComponent
          ),
        canActivate: [AuthGuard],
        data: { expectedRole: ['administrateur', 'utilisateur', 'contributeur', 'Fédération'] }
      },
      {
        path: 'standard/details/:id',
        loadComponent: () =>
          import('./collaboration/components/collaboration-evolutions/components/collaboration-evolutions-details/collaboration-evolutions-details.component').then(
            (m) => m.CollaborationEvolutionsDetailsComponent
          ),
        canActivate: [AuthGuard],
        data: { expectedRole: ['administrateur', 'utilisateur', 'contributeur', 'Fédération'] }
      },
      {
        path: 'codes/prefixes',
        loadComponent: () => import('./codes/codes-prefixes/codes-prefixes.component').then((m) => m.CodesPrefixesComponent),
        canActivate: [AuthGuard],
        data: { expectedRole: ['administrateur', 'utilisateur', 'contributeur'] }
      },
      {
        path: 'codes/prefixes/:result',
        loadComponent: () => import('./codes/codes-prefixes/codes-prefixes.component').then((m) => m.CodesPrefixesComponent),
        canActivate: [AuthGuard],
        data: { expectedRole: ['administrateur', 'utilisateur', 'contributeur'] }
      },
      {
        path: 'codes/autres',
        loadComponent: () => import('./codes/codes-others/codes-others.component').then((m) => m.CodesOthersComponent),
        canActivate: [AuthGuard],
        data: { expectedRole: ['administrateur', 'utilisateur', 'contributeur'] }
      },
            {
        path: 'codes/autres/:result',
        loadComponent: () => import('./codes/codes-others/codes-others.component').then((m) => m.CodesOthersComponent),
        canActivate: [AuthGuard],
        data: { expectedRole: ['administrateur', 'utilisateur', 'contributeur'] }
      },
      {
        path: 'codes/transfer',
        loadComponent: () => import('./codes/codes-transfer/codes-transfer.component').then((m) => m.CodesTransferComponent),
        canActivate: [AuthGuard],
        data: { expectedRole: ['administrateur'] }
      },
      {
        path: 'formulaire-inscription/:companyId',
        loadComponent: () => import('./administration/administration-profile/administration-profile.component').then((m) => m.AdministrationProfileComponent),
        canActivate: [AuthGuard]
      },
      { path: 'mentions-legales', loadComponent: () => import('./core/components/mentions-legales/mentions-legales.component').then((m) => m.MentionsLegalesComponent) },
      { path: '', redirectTo: 'accueil', pathMatch: 'full' }
    ]
  },
  {
    path: 'delegation',
    loadChildren: () => import('./delegation/routes').then((m) => m.DELEGATION_ROUTES),
    canActivate: [AuthGuard],
    data: { expectedRole: ['administrateur', 'utilisateur', 'contributeur'] }
  },
  {
    path: 'apim',
    loadChildren: () => import('./apim/routes').then((m) => m.APIM_ROUTES),
    canActivate: [AuthGuard],
    data: { expectedRole: ['administrateur', 'utilisateur', 'contributeur'] }
  },
  { path: 'signin-oidc', component: LoginComponent },
  { path: 'autologin', component: AutoLoginComponent },
  { path: 'unauthorizedContact/:code', component: UnauthorizedContactComponent },
  { path: 'unauthorizedContact/:code/:iat', component: UnauthorizedContactComponent },
  { path: 'unauthorizedAccount/:code', component: UnauthorizedAccountComponent },
  { path: '**', redirectTo: 'autologin' }
];
